module.exports = __webpack_public_path__ + "x.6501b971f8351ad42cce.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/images/social/x.png
// module id = ../../../../../src/assets/images/social/x.png
// module chunks = main